import axios from "axios";
import {
  IPreAuthQuery,
  IPreAuthQueryReply,
  QueryData,
} from "../interfaces/IPreAuthQuery";
import { PATIENT_APIS } from "../utils/constants";
import Axios from "../utils/axiosInterceptor";

export const QueryService = {
  async getQueries(
    caseId: number | string,
    visitInfoId: number | string,
    schemeMetaDataId: number | string,
    stageId: any
  ): Promise<QueryData[]> {
    try {
      const response = await Axios.post<QueryData[]>(
        `${PATIENT_APIS.GET_PRE_AUTH_QUERY_DATA}/${caseId}/visitInfo/${visitInfoId}/portalMetaDataId/${schemeMetaDataId}/getQueries`, {
          caseId: caseId,
          visitId: visitInfoId,
          portalMetaDataId: schemeMetaDataId,
          stageId: stageId
        }
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching queries:", error);
      throw error;
    }
  },
  async addQuery(
    queryData: IPreAuthQuery,
    caseId: number | string,
    visitInfoId: number | string,
    schemeMetaDataId: number | string
  ) {
    const response = await Axios.post(
      `${PATIENT_APIS.GET_PRE_AUTH_QUERY_DATA}/${caseId}/visitInfo/${visitInfoId}/portalMetaDataId/${schemeMetaDataId}/casePreAuthQueries`,
      queryData
    );
    return response.data;
  },
  async replyQuery(
    replyData: IPreAuthQueryReply,
    caseId: number | string,
    visitInfoId: number | string,
    schemeMetaDataId: number | string,
    casePreAuthQueryId: number | string
  ) {
    const response = await Axios.patch(
      `${PATIENT_APIS.GET_PRE_AUTH_QUERY_DATA}/${caseId}/visitInfo/${visitInfoId}/portalMetaDataId/${schemeMetaDataId}/casePreAuthQueries/${casePreAuthQueryId}`,
      replyData
    );
    return response.data;
  },
  async getQueryById(
    casePreAuthId: any
  ): Promise<QueryData> {
    try {
      const response = await Axios.get<QueryData>(
        `${PATIENT_APIS.GET_PRE_AUTH_QUERY_DATA_BY_ID}/${casePreAuthId}`,
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching queries:", error);
      throw error;
    }
  },
  async payerReplyQuery(
    caseId: any,
    visitId: any,
    casePreAuthQueryId: any,
    payload: any,
  ): Promise<any> {
    try {
      const response = await Axios.post(
        `${PATIENT_APIS.REPLY_PAYER_QUERY}/${caseId}/visitInfo/${visitId}/casePreAuthQueries/${casePreAuthQueryId}/bo-review`, payload,
      );
      return response.data;
    } catch (error) {
      console.error("Error replying query:", error);
      throw error;
    }
  },
  async getQueryHistory(
    casePreAuthQueryId: any,
  ): Promise<any> {
    try {
      const response = await Axios.get(
        `${PATIENT_APIS.GET_PRE_AUTH_QUERY_DATA_BY_ID}/${casePreAuthQueryId}/history`
      );
      return response.data;
    } catch (error) {
      console.error("Error in getting query history:", error);
      throw error;
    }
  },
};
